import ConfirmDeleteDialog from './ConfirmDeleteDialog'

export { ConfirmDeleteDialog }
export default ConfirmDeleteDialog
